/**
 * @desc 删除
 */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.Response;
export function request(code: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/skuFirmware/${code}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
